import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { paymentTypesLangKeys, PAYMENT_TYPES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';

const CheckoutPaymentTypes: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const paymentTypePickerOptions = useMemo((): IPickerOption[] => {
    const availablePaymentTypes = checkoutStore.availablePaymentTypes;
    if (
      checkoutStore.dependencies.order?.payment_type !== undefined &&
      !checkoutStore.isDraft &&
      !availablePaymentTypes.includes(checkoutStore.dependencies.order.payment_type)
    ) {
      availablePaymentTypes.push(checkoutStore.dependencies.order.payment_type);
    }

    return availablePaymentTypes.map((type) => {
      if (type === PAYMENT_TYPES.ONLINE_PAYMENT) {
        return { value: PAYMENT_TYPES.ONLINE_PAYMENT, label: 'online' };
      }

      return { value: type, label: paymentTypesLangKeys[type] };
    });
  }, [checkoutStore.availablePaymentTypes]);

  return (
    <div className="d-flex flex-column">
      {/* payment types picker */}
      <TabPicker
        value={checkoutStore.params.payment_type}
        options={paymentTypePickerOptions}
        onChange={checkoutStore.changePaymentType}
        disabled={!checkoutStore.isDraft}
        error={checkoutStore.validatorErrors.payment_type}
        className="width-fit"
      />
      {/* notification that client will receive SMS */}
      {checkoutStore.params.payment_type === PAYMENT_TYPES.ONLINE_PAYMENT ? (
        <p className="family-regular text-size-14 font-weight-400 mt-2">{localeStore.t('client_receive_sms_to_pay')}</p>
      ) : null}
    </div>
  );
});

export default CheckoutPaymentTypes;
